export default "__VITE_ASSET__BazgHru2__"